// tslint:disable
import { Injectable } from '@angular/core';

import { DwItem, DwItemDetail, DwQuery, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';

/************************************************
   Generated with the Devware CAP CLI 4.4.20
   Code Gen Name   Kickoff
   API Url         https://wappsdev.wachter.com/DevwareCapApi/

   Generated By    DEVWARE/Anthony.Monsees
   Generate On     12/23/2022 1:51:12 PM
************************************************/

export enum KickoffMetaDataItemNames {
    EthosJobNumber = 'Ethos_JobNumber',
    EthosJobNumberForecast = 'Ethos_JobNumberForecast',
    EthosJobNumberPhase = 'Ethos_JobNumberPhase',
    Kickoff = 'Kickoff',
    Milestone = 'Milestone',
    MilestoneCheckpoint = 'MilestoneCheckpoint',
    RoKickoff = 'roKickoff',
    RoMilestoneAndMilestoneCheckpoint = 'roMilestoneAndMilestoneCheckpoint',
}

export enum KickoffMetaDataLookups {
    EthosJobNumberActiveOnlyForKickoff = 1750,
    EthosJobNumberAllItems = 1378,
    EthosJobNumberEndDate = 1504,
    EthosJobNumberForecastAllItems = 1377,
    EthosJobNumberPhaseAllItems = 1588,
    KickoffAllItems = 1495,
    MilestoneAllItems = 1492,
    MilestoneCheckpointAllItems = 1491,
    OverheadJobNumbers = 1589,
    RoKickoffAllItems = 1627,
    RoMilestoneAndMilestoneCheckpointAllItems = 1494,
}

@Injectable({
    providedIn: 'root'
})
export class KickoffMetaDataService {

    EthosJobNumber : EthosJobNumber = new EthosJobNumber();
    EthosJobNumberForecast : EthosJobNumberForecast = new EthosJobNumberForecast();
    EthosJobNumberPhase : EthosJobNumberPhase = new EthosJobNumberPhase();
    Kickoff : Kickoff = new Kickoff();
    Milestone : Milestone = new Milestone();
    MilestoneCheckpoint : MilestoneCheckpoint = new MilestoneCheckpoint();
    RoKickoff : RoKickoff = new RoKickoff();
    RoMilestoneAndMilestoneCheckpoint : RoMilestoneAndMilestoneCheckpoint = new RoMilestoneAndMilestoneCheckpoint();
}

// Generated Classes for MetaData service
class EthosJobNumber implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumber.';

    constructor() {
        this.ItemDetail.ItemId=2375;
        this.ItemDetail.ItemName='Ethos_JobNumber';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumberStatusWs : string = this.i + 'JobNumberStatusWs';
    JobNumberStatus : string = this.i + 'JobNumberStatus';
    JobNumber : string = this.i + 'JobNumber';
    CustomerId : string = this.i + 'CustomerId';
    JobName : string = this.i + 'JobName';
    EstimatedStartDate : string = this.i + 'EstimatedStartDate';
    EstimatedEndDate : string = this.i + 'EstimatedEndDate';
    ProjectMgr1UserId : string = this.i + 'ProjectMgr1UserId';
    ProjectMgr2UserId : string = this.i + 'ProjectMgr2UserId';
    AsstProjectMgrUserId : string = this.i + 'AsstProjectMgrUserId';
    SeniorMgrUserId : string = this.i + 'SeniorMgrUserId';
    LeadTech1UserId : string = this.i + 'LeadTech1UserId';
    LeadTech2UserId : string = this.i + 'LeadTech2UserId';
    InvoiceApproval1UserId : string = this.i + 'InvoiceApproval1UserId';
    InvoiceApproval2UserId : string = this.i + 'InvoiceApproval2UserId';
    ForecastStatusCv : string = this.i + 'ForecastStatusCv';
    ForecastStatus : string = this.i + 'ForecastStatus';
    WachterTeamId : string = this.i + 'WachterTeamId';
    CustomerName : string = this.i + 'CustomerName';
    CustomerShortName : string = this.i + 'CustomerShortName';
    BillingInstructions : string = this.i + 'BillingInstructions';
    ChangeOrderProcessInstructions : string = this.i + 'ChangeOrderProcessInstructions';
    PartialBilling : string = this.i + 'PartialBilling';
    FinalInvoiceDate : string = this.i + 'FinalInvoiceDate';
    InvoiceDeliveryTypeData : string = this.i + 'InvoiceDeliveryTypeData';
    InvoiceDeliveryTypeCV : string = this.i + 'InvoiceDeliveryTypeCV';
    OpportunityId : string = this.i + 'OpportunityId';
    EndCustomerId : string = this.i + 'EndCustomerId';

    Relations = {
            /** Relation: Kickoff - Many */
            KickoffByEthosJobNumberId : {
                RelationName: 'Ethos_JobNumber|Kickoff|Ethos_JobNumberId',
                FieldPrefix: 'EthosKickoff',
                PropertyName: 'EthosKickoff'
            },
    };
}

class EthosJobNumberForecast implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberForecast.';

    constructor() {
        this.ItemDetail.ItemId=2374;
        this.ItemDetail.ItemName='Ethos_JobNumberForecast';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberForecastId : string = this.i + 'JobNumberForecastId';
    JobNumberId : string = this.i + 'JobNumberId';
    YeProjectedCosts : string = this.i + 'YeProjectedCosts';
    YeProjectedRevenue : string = this.i + 'YeProjectedRevenue';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedBy : string = this.i + 'CreatedBy';
    ModifiedBy : string = this.i + 'ModifiedBy';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    Notes : string = this.i + 'Notes';
    NoteAgingOverSixtyDays : string = this.i + 'NoteAgingOverSixtyDays';
    NoteOverUnderBilling : string = this.i + 'NoteOverUnderBilling';
    NoteLowForecastedGpm : string = this.i + 'NoteLowForecastedGpm';
    NoteChangedGpm : string = this.i + 'NoteChangedGpm';
    AXIntegrationID : string = this.i + 'AXIntegrationID';
    TotalForecastRevenue : string = this.i + 'TotalForecastRevenue';
    TotalForecastCost : string = this.i + 'TotalForecastCost';

    Relations = {
    };
}

class EthosJobNumberPhase implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberPhase.';

    constructor() {
        this.ItemDetail.ItemId=2552;
        this.ItemDetail.ItemName='Ethos_JobNumberPhase';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberPhaseId : string = this.i + 'JobNumberPhaseId';
    JobNumberId : string = this.i + 'JobNumberId';
    PhaseCode : string = this.i + 'PhaseCode';
    PhaseDescription : string = this.i + 'PhaseDescription';
    IsActive : string = this.i + 'IsActive';
    IsVisible : string = this.i + 'IsVisible';
    IsOnSite : string = this.i + 'IsOnSite';
    IsEstimate : string = this.i + 'IsEstimate';
    JobNumberPhaseStatusWs : string = this.i + 'JobNumberPhaseStatusWs';
    WorkflowStatusDisplay : string = this.i + 'WorkflowStatusDisplay';

    Relations = {
    };
}

class Kickoff implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Kickoff.';

    constructor() {
        this.ItemDetail.ItemId=2484;
        this.ItemDetail.ItemName='Kickoff';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    KickoffId : string = this.i + 'KickoffId';
    EthosJobNumberId : string = this.i + 'Ethos_JobNumberId';
    BillingInvoiceDate : string = this.i + 'BillingInvoiceDate';
    CloseoutMeetingDate : string = this.i + 'CloseoutMeetingDate';
    CloseoutDeliverableCompletedByDate : string = this.i + 'CloseoutDeliverableCompletedByDate';
    ExternalKickoffDate : string = this.i + 'ExternalKickoffDate';
    ScheduledStartDate : string = this.i + 'ScheduledStartDate';
    ScheduledEndDate : string = this.i + 'ScheduledEndDate';
    ScopeOfWork : string = this.i + 'ScopeOfWork';
    ChangeOrderProcessDescription : string = this.i + 'ChangeOrderProcessDescription';
    CustomerPaymentProcedure : string = this.i + 'CustomerPaymentProcedure';
    CustomerAccountingContactDetail : string = this.i + 'CustomerAccountingContactDetail';
    DeliverablesForBilling : string = this.i + 'DeliverablesForBilling';
    EscalationPathDescription : string = this.i + 'EscalationPathDescription';
    IntroductionText : string = this.i + 'IntroductionText';
    CommunicationDescription : string = this.i + 'CommunicationDescription';
    SafetyPlanDescription : string = this.i + 'SafetyPlanDescription';
    SiteContactInformation : string = this.i + 'SiteContactInformation';
    IsBillingACH : string = this.i + 'IsBillingACH';
    IsBuyerSignatureRequired : string = this.i + 'IsBuyerSignatureRequired';
    IsMonthlyBilling : string = this.i + 'IsMonthlyBilling';
    IsWrittenBillingApprovalRequired : string = this.i + 'IsWrittenBillingApprovalRequired';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    StakeholderInformation : string = this.i + 'StakeholderInformation';
    AttendeeInformation : string = this.i + 'AttendeeInformation';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    OtherNotes : string = this.i + 'OtherNotes';

    Relations = {
            /** Relation: Ro Kickoff */
            RoKickoff : {
                RelationName: 'Kickoff|roKickoff|KickoffId',
                FieldPrefix: 'RoKickoff',
                PropertyName: 'RoKickoff'
            },
            /** Relation: Job Number - Job Number */
            EthosJobNumberByEthosJobNumberId : {
                RelationName: 'Ethos_JobNumber|Kickoff|Ethos_JobNumberId',
                FieldPrefix: 'EthosEthosJobNumber',
                PropertyName: 'EthosEthosJobNumber'
            },
            /** Relation: Milestone */
            Milestone : {
                RelationName: 'Kickoff|Milestone|KickoffId',
                FieldPrefix: 'Milestone',
                PropertyName: 'Milestone'
            },
    };
}

class Milestone implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Milestone.';

    constructor() {
        this.ItemDetail.ItemId=2481;
        this.ItemDetail.ItemName='Milestone';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    MilestoneId : string = this.i + 'MilestoneId';
    KickoffId : string = this.i + 'KickoffId';
    Description : string = this.i + 'Description';
    DueDate : string = this.i + 'DueDate';
    IsDeleted : string = this.i + 'IsDeleted';

    Relations = {
            /** Relation: Kickoff */
            Kickoff : {
                RelationName: 'Kickoff|Milestone|KickoffId',
                FieldPrefix: 'Kickoff',
                PropertyName: 'Kickoff'
            },
            /** Relation: Milestone Checkpoint */
            MilestoneCheckpoint : {
                RelationName: 'Milestone|MilestoneCheckpoint|MilestoneId',
                FieldPrefix: 'MilestoneCheckpoint',
                PropertyName: 'MilestoneCheckpoint'
            },
    };
}

class MilestoneCheckpoint implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'MilestoneCheckpoint.';

    constructor() {
        this.ItemDetail.ItemId=2480;
        this.ItemDetail.ItemName='MilestoneCheckpoint';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    MilestoneCheckpointId : string = this.i + 'MilestoneCheckpointId';
    MilestoneId : string = this.i + 'MilestoneId';
    CheckpointDate : string = this.i + 'CheckpointDate';
    IsCheckpointCompleted : string = this.i + 'IsCheckpointCompleted';
    IsDeleted : string = this.i + 'IsDeleted';

    Relations = {
            /** Relation: Milestone */
            Milestone : {
                RelationName: 'Milestone|MilestoneCheckpoint|MilestoneId',
                FieldPrefix: 'Milestone',
                PropertyName: 'Milestone'
            },
    };
}

class RoKickoff implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roKickoff.';

    constructor() {
        this.ItemDetail.ItemId=2576;
        this.ItemDetail.ItemName='roKickoff';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    KickoffId : string = this.i + 'KickoffId';
    EthosJobNumberId : string = this.i + 'Ethos_JobNumberId';
    BillingInvoiceDate : string = this.i + 'BillingInvoiceDate';
    CloseoutMeetingDate : string = this.i + 'CloseoutMeetingDate';
    CloseoutDeliverableCompletedByDate : string = this.i + 'CloseoutDeliverableCompletedByDate';
    ExternalKickoffDate : string = this.i + 'ExternalKickoffDate';
    ScheduledStartDate : string = this.i + 'ScheduledStartDate';
    ScheduledEndDate : string = this.i + 'ScheduledEndDate';
    AttendeeInformation : string = this.i + 'AttendeeInformation';
    ScopeOfWork : string = this.i + 'ScopeOfWork';
    ChangeOrderProcessDescription : string = this.i + 'ChangeOrderProcessDescription';
    CustomerPaymentProcedure : string = this.i + 'CustomerPaymentProcedure';
    CustomerAccountingContactDetail : string = this.i + 'CustomerAccountingContactDetail';
    DeliverablesForBilling : string = this.i + 'DeliverablesForBilling';
    EscalationPathDescription : string = this.i + 'EscalationPathDescription';
    IntroductionText : string = this.i + 'IntroductionText';
    CommunicationDescription : string = this.i + 'CommunicationDescription';
    SafetyPlanDescription : string = this.i + 'SafetyPlanDescription';
    SiteContactInformation : string = this.i + 'SiteContactInformation';
    StakeholderInformation : string = this.i + 'StakeholderInformation';
    OtherNotes : string = this.i + 'OtherNotes';
    IsBillingACH : string = this.i + 'IsBillingACH';
    IsBuyerSignatureRequired : string = this.i + 'IsBuyerSignatureRequired';
    IsMonthlyBilling : string = this.i + 'IsMonthlyBilling';
    IsWrittenBillingApprovalRequired : string = this.i + 'IsWrittenBillingApprovalRequired';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    JobNumber : string = this.i + 'JobNumber';
    JobYear : string = this.i + 'JobYear';
    WachterTeamCode : string = this.i + 'WachterTeamCode';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    ProjectManager : string = this.i + 'ProjectManager';
    ProjectManagerUserId : string = this.i + 'ProjectManagerUserId';
    WachterDepartmentCode : string = this.i + 'WachterDepartmentCode';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    WachterDivisionCode : string = this.i + 'WachterDivisionCode';

    Relations = {
            /** Relation: Kickoff */
            Kickoff : {
                RelationName: 'Kickoff|roKickoff|KickoffId',
                FieldPrefix: 'Kickoff',
                PropertyName: 'Kickoff'
            },
    };
}

class RoMilestoneAndMilestoneCheckpoint implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roMilestoneAndMilestoneCheckpoint.';

    constructor() {
        this.ItemDetail.ItemId=2483;
        this.ItemDetail.ItemName='roMilestoneAndMilestoneCheckpoint';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    MilestoneId : string = this.i + 'MilestoneId';
    KickoffId : string = this.i + 'KickoffId';
    Description : string = this.i + 'Description';
    DueDate : string = this.i + 'DueDate';
    MilestoneCheckpointId : string = this.i + 'MilestoneCheckpointId';
    CheckpointDate : string = this.i + 'CheckpointDate';
    IsCheckpointCompleted : string = this.i + 'IsCheckpointCompleted';

    Relations = {
    };
}


export class KickoffMetaData {

    static EthosJobNumber : EthosJobNumber = new EthosJobNumber();
    static EthosJobNumberForecast : EthosJobNumberForecast = new EthosJobNumberForecast();
    static EthosJobNumberPhase : EthosJobNumberPhase = new EthosJobNumberPhase();
    static Kickoff : Kickoff = new Kickoff();
    static Milestone : Milestone = new Milestone();
    static MilestoneCheckpoint : MilestoneCheckpoint = new MilestoneCheckpoint();
    static RoKickoff : RoKickoff = new RoKickoff();
    static RoMilestoneAndMilestoneCheckpoint : RoMilestoneAndMilestoneCheckpoint = new RoMilestoneAndMilestoneCheckpoint();
}

// Generated Entity Interfaces
export interface EthosJobNumberEntity extends DwOrmData {
    // Attributes
    JobNumberId?: number;
    JobNumberStatusWs?: number;
    JobNumberStatus?: string;
    JobNumber?: string;
    CustomerId?: number;
    JobName?: string;
    EstimatedStartDate?: string;
    EstimatedEndDate?: string;
    ProjectMgr1UserId?: number;
    ProjectMgr2UserId?: number;
    AsstProjectMgrUserId?: number;
    SeniorMgrUserId?: number;
    LeadTech1UserId?: number;
    LeadTech2UserId?: number;
    InvoiceApproval1UserId?: number;
    InvoiceApproval2UserId?: number;
    ForecastStatusCv?: number;
    ForecastStatus?: string;
    WachterTeamId?: number;
    CustomerName?: string;
    CustomerShortName?: string;
    BillingInstructions?: string;
    ChangeOrderProcessInstructions?: string;
    PartialBilling?: boolean;
    FinalInvoiceDate?: string;
    InvoiceDeliveryTypeData?: string;
    InvoiceDeliveryTypeCV?: number;
    OpportunityId?: number;
    EndCustomerId?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    JobNumberStatusWsDisplay?: string;
    CustomerIdDisplay?: string;
    ProjectMgr1UserIdDisplay?: string;
    ProjectMgr2UserIdDisplay?: string;
    AsstProjectMgrUserIdDisplay?: string;
    SeniorMgrUserIdDisplay?: string;
    LeadTech1UserIdDisplay?: string;
    LeadTech2UserIdDisplay?: string;
    InvoiceApproval1UserIdDisplay?: string;
    InvoiceApproval2UserIdDisplay?: string;
    InvoiceDeliveryTypeCVDisplay?: string;
    OpportunityIdDisplay?: string;
    EndCustomerIdDisplay?: string;
    // Relations
    EthosKickoff? : KickoffEntity[];
}

export interface EthosJobNumberForecastEntity extends DwOrmData {
    // Attributes
    JobNumberForecastId?: number;
    JobNumberId?: number;
    YeProjectedCosts?: number;
    YeProjectedRevenue?: number;
    IsDeleted?: boolean;
    CreatedBy?: number;
    ModifiedBy?: number;
    CreatedDateTime?: string;
    ModifiedDateTime?: string;
    Notes?: string;
    NoteAgingOverSixtyDays?: string;
    NoteOverUnderBilling?: string;
    NoteLowForecastedGpm?: string;
    NoteChangedGpm?: string;
    AXIntegrationID?: string;
    TotalForecastRevenue?: number;
    TotalForecastCost?: number;

    // Relations
}

export interface EthosJobNumberPhaseEntity extends DwOrmData {
    // Attributes
    JobNumberPhaseId?: number;
    JobNumberId?: number;
    PhaseCode?: string;
    PhaseDescription?: string;
    IsActive?: boolean;
    IsVisible?: boolean;
    IsOnSite?: boolean;
    IsEstimate?: boolean;
    JobNumberPhaseStatusWs?: number;
    WorkflowStatusDisplay?: string;

    // Relations
}

export interface KickoffEntity extends DwOrmData {
    // Attributes
    KickoffId?: number;
    Ethos_JobNumberId?: number;
    BillingInvoiceDate?: string;
    CloseoutMeetingDate?: string;
    CloseoutDeliverableCompletedByDate?: string;
    ExternalKickoffDate?: string;
    ScheduledStartDate?: string;
    ScheduledEndDate?: string;
    ScopeOfWork?: string;
    ChangeOrderProcessDescription?: string;
    CustomerPaymentProcedure?: string;
    CustomerAccountingContactDetail?: string;
    DeliverablesForBilling?: string;
    EscalationPathDescription?: string;
    IntroductionText?: string;
    CommunicationDescription?: string;
    SafetyPlanDescription?: string;
    SiteContactInformation?: string;
    IsBillingACH?: boolean;
    IsBuyerSignatureRequired?: boolean;
    IsMonthlyBilling?: boolean;
    IsWrittenBillingApprovalRequired?: boolean;
    IsDeleted?: boolean;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    StakeholderInformation?: string;
    AttendeeInformation?: string;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    OtherNotes?: string;

    // Display Attributes
    Ethos_JobNumberIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    // Relations
    RoKickoff? : RoKickoffEntity[];
    EthosEthosJobNumber? : EthosJobNumberEntity;
    Milestone? : MilestoneEntity[];
}

export interface MilestoneEntity extends DwOrmData {
    // Attributes
    MilestoneId?: number;
    KickoffId?: number;
    Description?: string;
    DueDate?: string;
    IsDeleted?: boolean;

    // Display Attributes
    KickoffIdDisplay?: string;
    // Relations
    Kickoff? : KickoffEntity;
    MilestoneCheckpoint? : MilestoneCheckpointEntity[];
}

export interface MilestoneCheckpointEntity extends DwOrmData {
    // Attributes
    MilestoneCheckpointId?: number;
    MilestoneId?: number;
    CheckpointDate?: string;
    IsCheckpointCompleted?: boolean;
    IsDeleted?: boolean;

    // Display Attributes
    MilestoneIdDisplay?: string;
    // Relations
    Milestone? : MilestoneEntity;
}

export interface RoKickoffEntity extends DwOrmData {
    // Attributes
    KickoffId?: number;
    Ethos_JobNumberId?: number;
    BillingInvoiceDate?: string;
    CloseoutMeetingDate?: string;
    CloseoutDeliverableCompletedByDate?: string;
    ExternalKickoffDate?: string;
    ScheduledStartDate?: string;
    ScheduledEndDate?: string;
    AttendeeInformation?: string;
    ScopeOfWork?: string;
    ChangeOrderProcessDescription?: string;
    CustomerPaymentProcedure?: string;
    CustomerAccountingContactDetail?: string;
    DeliverablesForBilling?: string;
    EscalationPathDescription?: string;
    IntroductionText?: string;
    CommunicationDescription?: string;
    SafetyPlanDescription?: string;
    SiteContactInformation?: string;
    StakeholderInformation?: string;
    OtherNotes?: string;
    IsBillingACH?: boolean;
    IsBuyerSignatureRequired?: boolean;
    IsMonthlyBilling?: boolean;
    IsWrittenBillingApprovalRequired?: boolean;
    IsDeleted?: boolean;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    JobNumber?: string;
    JobYear?: number;
    WachterTeamCode?: string;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    ProjectManager?: string;
    ProjectManagerUserId?: number;
    WachterDepartmentCode?: string;
    WachterDivisionId?: number;
    WachterDivisionCode?: string;

    // Display Attributes
    Ethos_JobNumberIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    // Relations
    Kickoff? : KickoffEntity;
}

export interface RoMilestoneAndMilestoneCheckpointEntity extends DwOrmData {
    // Attributes
    MilestoneId?: number;
    KickoffId?: number;
    Description?: string;
    DueDate?: string;
    MilestoneCheckpointId?: number;
    CheckpointDate?: string;
    IsCheckpointCompleted?: boolean;

    // Relations
}



